// @flow
import styled from "styled-components"

export const PageWrap = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

export const HeaderWrap = styled.header`
  width: 100%;
  z-index: ${(props) => props.theme.zIndices.header};
`

export const MessageWrap = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`

export const NavWrap = styled.div`
  padding: 1rem 0;
  background-color: ${(props) => props.theme.color.light};
`;

export const BodyWrap = styled.main`
  flex: 1;
`

export const FooterWrap = styled.footer`
`

export const Line = styled.div`
  border-bottom: 0.1rem solid ${(props) => props.theme.color.light};
`;

export const PageContent = styled.div`
  padding-top: 6rem;
`

export const PageContentWithFilter = styled.div`
  padding-top: 11.1rem;
`


// WEBPACK FOOTER //
// ./src/pages/_Page/styled.js